module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_gross_and_micro-4ce3c16690618cbe82eb8451d502aed3.svg";